import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { toast } from 'sonner';

const SECTION_LABELS = {
  partners: '🎾 חיפוש פרטנרים למשחק',
  gear: '🛒 לוח ציוד יד שנייה/חדש',
  coaches: '🎓 מאמני טניס',
  camps: '✈️ מחנות אימונים בחו״ל',
  whatsapp: '💬 קהילת וואטסאפ',
};

export const HomeSectionsEditor = ({ open, onClose, order, onSaved }) => {
  const { API } = useContext(AuthContext);
  const [localOrder, setLocalOrder] = useState(order);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setLocalOrder(order); }, [open, order]);

  const move = (idx, dir) => {
    const next = [...localOrder];
    const target = idx + dir;
    if (target < 0 || target >= next.length) return;
    [next[idx], next[target]] = [next[target], next[idx]];
    setLocalOrder(next);
  };

  const save = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      await axios.put(`${API}/homepage-sections`, { order: localOrder }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('סדר הקטגוריות נשמר! ✅');
      onSaved(localOrder);
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'שגיאה בשמירה');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm" dir="rtl" data-testid="sections-order-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl">⚙️ סדר קטגוריות בעמוד הבית</DialogTitle>
          <DialogDescription>השתמש בחצים כדי לשנות את סדר ההצגה</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {localOrder.map((key, idx) => (
            <div key={key} className="flex items-center gap-2 rounded-xl border p-3 bg-white dark:bg-slate-800" data-testid={`section-row-${key}`}>
              <span className="font-bold text-gray-700 dark:text-gray-200 text-sm flex-1">{SECTION_LABELS[key]}</span>
              <button onClick={() => move(idx, -1)} disabled={idx === 0} className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-slate-700 disabled:opacity-30" data-testid={`section-up-${key}`}>
                <ArrowUp className="w-4 h-4" />
              </button>
              <button onClick={() => move(idx, 1)} disabled={idx === localOrder.length - 1} className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-slate-700 disabled:opacity-30" data-testid={`section-down-${key}`}>
                <ArrowDown className="w-4 h-4" />
              </button>
            </div>
          ))}
          <Button onClick={save} disabled={saving} className="w-full bg-gradient-to-l from-blue-600 to-green-600 rounded-full py-5 font-bold" data-testid="save-sections-order-btn">
            {saving ? 'שומר...' : 'שמור סדר ✅'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
